export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们 / 投稿合作
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            如果您有影视资源推荐、内容合作意向或任何问题咨询，欢迎通过以下方式与我们取得联系。
            90影视团队致力于为影迷提供更优质的观影服务，期待您的宝贵建议与投稿。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-lg border border-background-300/60 w-full sm:w-auto">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-mail-line text-xl text-accent-500"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-500">投稿邮箱</p>
                <p className="text-sm font-medium text-foreground-800">contact@90ys.tv</p>
              </div>
            </div>
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-lg border border-background-300/60 w-full sm:w-auto">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-wechat-line text-xl text-primary-500"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-500">官方微信</p>
                <p className="text-sm font-medium text-foreground-800">90ys_official</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}